// extracted by mini-css-extract-plugin
module.exports = {"bleed":"ContainerBleed-module--bleed--xdVv_","noMargin":"ContainerBleed-module--noMargin--1baRz"};